import { useContext, useState } from "react";
import axios from "../../../Axios";
import { Urls } from "../../../Urls";
import { DateFormatter3 } from "../../../Constants";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";

export const useNewEnquiryFilters = (props) => {
  const {
    company_mail,
    interval_days,
    setinterval_days,
    userview,
    setuserview,
    cancelEnquiry,
    setcancelEnquiry,
    expiredEnquiries,
    setexpiredEnquiries,
    approveEnquiry,
    setapproveEnquiry,
    planningbutton,
    setshow,
    setskipLimit,
    setSkipactive,
    skipactive,
    settotalcount,
    setfiltered_details,
    reload_data,
    filter,
    setIsApprover,
    history,
    mapEnquiryData,
    TrackMixPanel,
    visible_enquiry,
  } = props;

  const [selected_origin_name, setselected_origin_name] = useState();
  const [selected_destination_name, setselected_destination_name] = useState();
  const [selected_truck_type, setselected_truck_type] = useState();
  const [selected_user, setselected_user] = useState();
  const [selected_placement_date, setselected_placement_date] = useState();
  const [selected_contract, setselected_contract] = useState();
  const [filters_applied, setFilters_applied] = useState(false);
  const [list_user, setlist_user] = useState([]);
  const [list_origins, setlist_origins] = useState([]);
  const [list_destinations, setlist_destinations] = useState([]);
  const [list_trucks, setlist_trucks] = useState([]);
  const [list_placement, setlist_placement] = useState([]);
  const [list_contract, setlist_contract] = useState([]);
  const [list_adhoc_ids, setlist_adhoc_ids] = useState([]);
  const [selected_adhoc_id, setselected_adhoc_id] = useState("");
  const { userDetails } = useContext(UserApiContext)
  const apply_Filter = (firsttime, skipval, limit, skip, val, valueof) => {
    if (firsttime) {
      setFilters_applied(false);
      setSkipactive(skipval);
      if (valueof === "active") {
        setcancelEnquiry(false);
        setexpiredEnquiries(false);
        setapproveEnquiry(false);
      } else if (valueof === "approved") {
        setapproveEnquiry(true);
        setcancelEnquiry(false);
        setexpiredEnquiries(false);
      } else if (valueof === "cancelled") {
        setcancelEnquiry(true);
        setexpiredEnquiries(false);
        setapproveEnquiry(false);
      } else if (valueof === "expired") {
        setcancelEnquiry(false);
        setexpiredEnquiries(true);
        setapproveEnquiry(false);
      } else if (valueof === "all") {
        setcancelEnquiry(false);
        setexpiredEnquiries(false);
        setapproveEnquiry(false);
      }
      if (valueof === "one_day") setinterval_days(1);
      if (valueof === "seven_days") setinterval_days(7);
      if (valueof === "fifteen_days") setinterval_days(15);
      if (valueof === "one_month") setinterval_days(30);
      if (valueof === "three_month") setinterval_days(90);
      if (valueof === "six_month") setinterval_days(180);
      if (!planningbutton) setshow(true);
      setskipLimit(skip);

      const getLocalYMD = (d) => `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(-2)}-${("0" + d.getDate()).slice(-2)}`;
      const tDate = new Date();
      const toDateString = getLocalYMD(tDate);
      tDate.setDate(tDate.getDate() - 7);
      const fromDateString = getLocalYMD(tDate);

      var payload = {
        company_id: userDetails?.profile_company_id,
        email: company_mail || userDetails.email,
        bucket:
          (valueof === "approved" || approveEnquiry) &&
            valueof !== "active" &&
            valueof !== "expired" &&
            valueof !== "cancelled"
            ? "approved"
            : (valueof === "cancelled" || cancelEnquiry) &&
              valueof !== "active" &&
              valueof !== "expired" &&
              valueof !== "approved"
              ? "cancelled"
              : (valueof === "expired" || expiredEnquiries) &&
                valueof !== "active" &&
                valueof !== "cancelled" &&
                valueof !== "approved"
                ? "expired"
                : valueof === "all"
                  ? "all"
                  : "active",
        view:
          valueof === "company_view"
            ? "company_view"
            : !userview && valueof !== "user_view"
              ? "company_view"
              : "user_view",
        filtersOperator: "and",
        filters: [
          {
            label: "Created Date",
            op: "between",
            key: "created_date",
            type: "date",
            values: [fromDateString, toDateString],
          },
        ],
        date_range: [],
        search: "",
        sort: {
          key: "created_date",
          order: "desc",
        },
        pagination: { skip: skip === "" ? 0 : skip, limit: limit || 50 },
      };

      if (!planningbutton) {
        axios
          .post(Urls.spot_data, payload)
          .then((res) => {
            const total = res.data.total_count || res.data.total_enquiries || 0;
            const maxPages = Math.ceil(total / limit);
            if (skipval > maxPages && maxPages > 0) {
              const params = new URLSearchParams(history.location.search);
              params.set("page", "1");
              history.replace(`/trucks/enquiries?${params.toString()}`);
              apply_Filter(true, 1, limit, 0, 0, valueof);
              return;
            }

            setSkipactive(skipval);
            settotalcount(total);
            const mappedList = mapEnquiryData(res.data.enquiry_list || []);
            setfiltered_details(mappedList);
            setshow(false);

            if (
              res &&
              res.data &&
              res.data.enquiry_list &&
              res.data.enquiry_list.length > 0
            ) {
              reload_data(mappedList);
            }
            if (filter) {
              filtersClicked(
                expiredEnquiries
                  ? "expired"
                  : cancelEnquiry
                    ? "cancelled"
                    : approveEnquiry
                      ? "approved"
                      : "active",
                valueof
              );
            }
            if (res.data.users) {
              setlist_user(res.data.users);
            }
          })
          .catch((e) => {
            setshow(false);
            console.log(e);
          });
      }
    } else {
      const buildPayload = (withpagination) => {
        var payload = {
          module_name: "spot",
          enquiry_view:
            userview ||
              (valueof === "email" && val && val.value) ||
              (valueof !== "email" && selected_user)
              ? "user_view"
              : "company_view",
          email:
            valueof === "email" && val && val.value
              ? val.value
              : valueof !== "email" && selected_user
                ? selected_user
                : company_mail,
          bucket: "all",
          days: interval_days,
          origin:
            valueof === "enquiry_lane_details.origin.location_name" && val
              ? val.value
              : selected_origin_name
                ? selected_origin_name
                : "",
          destination:
            valueof === "enquiry_lane_details.destination.location_name" && val
              ? val.value
              : selected_destination_name
                ? selected_destination_name
                : "",
          due_date:
            valueof === "enquiry_lane_details.due_date" && val
              ? val.value && val.value.days
                ? val.value.days.map((value) => DateFormatter3(value))
                : []
              : selected_placement_date &&
                selected_placement_date.days &&
                selected_placement_date.days.length > 0
                ? selected_placement_date.days.map((value) =>
                  DateFormatter3(value)
                )
                : [],
          contract_tenure:
            valueof === "enquiry_lane_details.contract_tenure.label" && val
              ? val.value
              : selected_contract
                ? selected_contract
                : "",
          truck_types:
            valueof === "enquiry_lane_details.truck_types.value" && val
              ? val.value
              : selected_truck_type
                ? selected_truck_type
                : "",
          display_adhoc_ids:
            valueof === "display_adhoc_ids" && val
              ? val.value
              : selected_adhoc_id
                ? selected_adhoc_id
                : "",
        };
        if (withpagination) {
          payload["skip"] = skipval > 0 ? skip : 0;
          payload["limit"] = limit;
        }
        TrackMixPanel({
          ModuleName: "lorri spot",
          ScreenName: "my enquiries - analytics filters",
          Data: `lane: ${payload && payload.origin && payload.origin.location_name
            ? payload.origin.location_name
            : ""
            } to ${payload && payload.destination && payload.destination.location_name
              ? payload.destination.location_name
              : ""
            }, truck type: ${payload?.truck_types}, due date: ${payload?.due_date
            }, enquiry view: ${payload.enquiry_view}, email: ${payload.email
            }, bucket: ${payload.bucket} `,
          Definition: "user filtered my enquiries",
        });
        return payload;
      };
      setshow(true);
      setFilters_applied(true);
      setSkipactive(skipval);
      setskipLimit(skip);
      axios
        .post(`${Urls.spot_filters}`, buildPayload(true))
        .then((res) => {
          setSkipactive(skipval);
          settotalcount(res.data.all_documents_count);
          setfiltered_details(res.data.filtered_data.enquiry_list);
          reload_data(res.data.filtered_data.enquiry_list);
        })
        .catch((e) => {
          setshow(false);
          console.log(e);
        });
      axios
        .post(`${Urls.spot_filters}?get_filters=true`, buildPayload(false))
        .then((res) => {
          var origin_locationname_list = res.data[
            "enquiry_origin_locations"
          ].map((val) => {
            if (val !== null && val !== undefined && val !== "") {
              return val;
            }
          });
          setlist_origins(origin_locationname_list);

          var destination_locationname_list = res.data[
            "enquiry_destination_locations"
          ].map((val) => {
            if (val !== null && val !== undefined && val !== "") {
              return val;
            }
          });
          setlist_destinations(destination_locationname_list);

          var truck_type_list = res.data["enquiry_truck_types"].map((val) => {
            if (val !== null && val !== undefined && val !== "") {
              return val;
            }
          });
          setlist_trucks(truck_type_list);

          var contract_type = res.data["enquiry_contract_tenure"].map((val) => {
            if (val !== null && val !== undefined && val !== "") {
              return val;
            }
          });
          setlist_contract(contract_type);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const filtersClicked = (valueof, email_value) => {
    if (email_value === "one_day") {
      setinterval_days(1);
    }
    if (email_value === "seven_days") {
      setinterval_days(7);
    }
    if (email_value === "fifteen_days") {
      setinterval_days(15);
    }
    if (email_value === "one_month") {
      setinterval_days(30);
    }
    if (email_value === "three_month") {
      setinterval_days(90);
    }
    if (email_value === "six_month") {
      setinterval_days(180);
    }
    var payload = {
      module_name: "spot",
      enquiry_view: userview ? "user_view" : "company_view",
      email:
        email_value !== "email" && selected_user ? selected_user : company_mail,
      bucket: "all",
      days:
        email_value === "one_day"
          ? 1
          : email_value === "seven_days"
            ? 7
            : email_value === "fifteen_days"
              ? 15
              : email_value === "one_month"
                ? 30
                : email_value === "three_month"
                  ? 90
                  : email_value === "six_month"
                    ? 180
                    : interval_days,
      origin:
        selected_origin_name && !filters_applied ? selected_origin_name : "",
      destination:
        selected_destination_name && !filters_applied
          ? selected_destination_name
          : "",
      due_date:
        !filters_applied &&
          selected_placement_date &&
          selected_placement_date.days &&
          selected_placement_date.days.length > 0
          ? selected_placement_date.days.map((value) => DateFormatter3(value))
          : [],
      contract_tenure:
        selected_contract && !filters_applied ? selected_contract : "",
      truck_types:
        selected_truck_type && !filters_applied ? selected_truck_type : "",
      display_adhoc_ids:
        valueof === "display_adhoc_ids" && selected_adhoc_id // val isn't defined here so I used selected_adhoc_id. In the original code, `val` was undefined in filtersClicked. Wait, I should keep it identical if possible. I'll just change val to undefined to match, or just use selected_adhoc_id since val isn't available. Let's see how it was in original. `valueof === "display_adhoc_ids" && val ? val.value : selected_adhoc_id ? selected_adhoc_id : ""`
          ? selected_adhoc_id
          : selected_adhoc_id
            ? selected_adhoc_id
            : "",
    };

    axios
      .post(`${Urls.spot_filters}?get_filters=true`, payload)
      .then((res) => {
        if (res && res.data) {
          var origin_locationname_list = res.data?.[
            "enquiry_origin_locations"
          ].map((val) => {
            if (val !== null && val !== undefined && val !== "") {
              return val;
            }
          });
          setlist_origins(origin_locationname_list);

          var destination_locationname_list = res.data?.[
            "enquiry_destination_locations"
          ].map((val) => {
            if (val !== null && val !== undefined && val !== "") {
              return val;
            }
          });
          setlist_destinations(destination_locationname_list);

          var truck_type_list = res.data?.["enquiry_truck_types"].map((val) => {
            if (val !== null && val !== undefined && val !== "") {
              return val;
            }
          });
          setlist_trucks(truck_type_list);
          var adhoc_list = res.data?.["display_adhoc_ids"]?.map((val) => {
            if (val !== null && val !== undefined && val !== "") {
              return val;
            }
          });
          setlist_adhoc_ids(adhoc_list);
          var contract_type = res.data?.["enquiry_contract_tenure"].map(
            (val) => {
              if (val !== null && val !== undefined && val !== "") {
                return val;
              }
            }
          );
          setlist_contract(contract_type);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return {
    selected_origin_name, setselected_origin_name,
    selected_destination_name, setselected_destination_name,
    selected_truck_type, setselected_truck_type,
    selected_user, setselected_user,
    selected_placement_date, setselected_placement_date,
    selected_contract, setselected_contract,
    filters_applied, setFilters_applied,
    list_user, setlist_user,
    list_origins, setlist_origins,
    list_destinations, setlist_destinations,
    list_trucks, setlist_trucks,
    list_placement, setlist_placement,
    list_contract, setlist_contract,
    list_adhoc_ids, setlist_adhoc_ids,
    selected_adhoc_id, setselected_adhoc_id,
    apply_Filter,
    filtersClicked
  };
};
